// IMPORTANT: for now, statement will not need JWT because it shows data from memory
// in the future, is a client may get money from another client, a kind of sync will be necessary
// same for balance !

import React from 'react';
import Card from './Card.js';
import { UserContext } from '../context.js';
import AccountStatement from './AccountStatement';

function Statement () {
    const ctx = React.useContext(UserContext);

    const showAccountStatement = (user) => {
      return (
        (user ? (
        <div className="accountStatement">
          <div>{`Name: ${user.name}`}</div>
          <div>{`Email: ${user.email}`}</div>
          <div>{`Balance $: ${user.balance}`}</div>
          <div className="statementEntries">
            <AccountStatement aUser={user}/>
          </div>
        </div>
        ):(
          <div className="noUser">
            No client data
          </div>
        ))
      )
    }

    return (
      <Card
        bgcolor="secondary"
        txtcolor="white"
        header="Account Statement"
        body={ctx.currentUser ?
            (
              <div className="statement">
              <div className="statement-currentUser"></div>
              <div className="statement-currentUser-data">{ (ctx.currentUser) ? showAccountStatement(ctx.currentUser) : 'No user currently logged in'}</div>
              </div>
            ):(
              <div className="operation-unlogged">
              Please log in
              </div>  
            )

          }
      />    
    );  
};

export default Statement;
